<script>
import { cloneDeep, pickBy } from 'lodash-es';
import Calculator from '../../utils/calculator';
import NonDynamicTransportNotificationRow from './NonDynamicTransportNotificationRow';
import NonDynamicTransportNotifications from './NonDynamicTransportNotifications';

export default {
  name: 'NonDynamicTransportAllotmentRow',
  components: {
    NonDynamicTransportNotificationRow,
    NonDynamicTransportNotifications,
  },
  props: {
    allotment: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localAllotment: null,
      percentages: {
        totalFare: null,
        infant: null,
        child: null,
      },
      datePickerMenuFromDate: false,
      datePickerMenuToDate: false,
      datePickerMenuReleaseDate: false,
      notificationMenu: false,
      notification: {
        type: null,
        days: null,
      },
      localNotifications: [],
      days: [
        {
          day: 'monday',
          label: 'Mo',
        },
        {
          day: 'tuesday',
          label: 'Tu',
        },
        {
          day: 'wednesday',
          label: 'We',
        },
        {
          day: 'thursday',
          label: 'Th',
        },
        {
          day: 'friday',
          label: 'Fr',
        },
        {
          day: 'saturday',
          label: 'Sa',
        },
        {
          day: 'sunday',
          label: 'Su',
        },
      ],
      infoModal: false,
      inboundDays: [],
      outboundDays: [],
    };
  },
  created() {
    this.setLocalAllotment(this.allotment);
    if (this.allotment.prices.adult) {
      this.calculateTotalFarePercentage();
      this.calculateInfantPercentage();
      this.calculateChildPercentage();
    }
    this.setDays();
  },
  methods: {
    calculateTotalFare() {
      const taxes = +this.localAllotment.fares.tax;
      const fuel = +this.localAllotment.fares.fuel;
      const net = +this.localAllotment.fares.net;
      this.localAllotment.fares.total = taxes + fuel + net;
      this.calculateCustomerPrice();
    },
    calculateTotalFarePercentage() {
      const totalFare = +this.localAllotment.fares.total;
      const customerPrice = +this.localAllotment.prices.adult;
      const percentage = Calculator.calculatePercentageDifference(
        totalFare,
        customerPrice,
        2,
      );
      this.percentages.totalFare = percentage;
    },
    calculateCustomerPrice() {
      const totalFare = +this.localAllotment.fares.total;
      const percentage = +this.percentages.totalFare;
      this.localAllotment.prices.adult = Calculator.roundNumber(totalFare / (1 - (percentage / 100)), 2);
      this.calculateInfantPrice();
      this.calculateChildPrice();
    },
    calculateInfantPrice() {
      const customerPrice = +this.localAllotment.prices.adult;
      const percentage = +this.percentages.infant;
      const difference = Calculator.calculateDifferenceByPercentage(
        percentage,
        customerPrice,
        2,
      );
      this.localAllotment.prices.infant = difference;
    },
    calculateInfantPercentage() {
      const customerPrice = +this.localAllotment.prices.adult;
      const infantPrice = +this.localAllotment.prices.infant;
      this.percentages.infant = Calculator.calculatePercentage(
        customerPrice,
        infantPrice,
        2,
      );
    },
    calculateChildPrice() {
      const customerPrice = +this.localAllotment.prices.adult;
      const percentage = +this.percentages.child;
      const difference = Calculator.calculateDifferenceByPercentage(
        percentage,
        customerPrice,
        2,
      );
      this.localAllotment.prices.child = difference;
    },
    calculateChildPercentage() {
      const customerPrice = +this.localAllotment.prices.adult;
      const childPrice = +this.localAllotment.prices.child;
      this.percentages.child = Calculator.calculatePercentage(
        customerPrice,
        childPrice,
        2,
      );
    },
    setLocalAllotment(allotment) {
      this.localAllotment = cloneDeep(allotment);
    },
    updateInboundDays(days) {
      const daysNotSet = this.compareDays(this.days, days);
      for (let i = 0; i < daysNotSet.length; i += 1) {
        this.localAllotment.days.inbound[daysNotSet[i].day] = false;
      }
      for (let i = 0; i < days.length; i += 1) {
        this.localAllotment.days.inbound[days[i].day] = true;
      }
    },
    updateOutboundDays(days) {
      const daysNotSet = this.compareDays(this.days, days);
      for (let i = 0; i < daysNotSet.length; i += 1) {
        this.localAllotment.days.outbound[daysNotSet[i].day] = false;
      }
      for (let i = 0; i < days.length; i += 1) {
        this.localAllotment.days.outbound[days[i].day] = true;
      }
    },
    compareDays(originalDays, days) {
      return originalDays.filter(
        dayA => !days.some(dayB => dayA.day === dayB.day),
      );
    },
    setNotifications(items) {
      this.localAllotment.notifications = items;
    },
    clearReleaseDate() {
      this.localAllotment.releaseDate = null;
    },
    setDays() {
      this.inboundDays = [];
      this.outboundDays = [];
      const inboundDaysSet = pickBy(
        this.allotment.days.inbound,
        value => value,
      );
      const inboundDayKeys = Object.keys(inboundDaysSet);

      inboundDayKeys.forEach((element) => {
        this.days.forEach((day) => {
          if (element === day.day) {
            this.inboundDays.push(day);
          }
        });
      });

      const outboundDaysSet = pickBy(
        this.allotment.days.outbound,
        value => value,
      );
      const outboundDayKeys = Object.keys(outboundDaysSet);

      outboundDayKeys.forEach((element) => {
        this.days.forEach((day) => {
          if (element === day.day) {
            this.outboundDays.push(day);
          }
        });
      });
    },
    openNDT() {
      location.href = `/non-dynamic-transportation/edit/${this.allotment.transportId}`;
    },
  },
  watch: {
    localAllotment: {
      handler(value) {
        this.$emit('change', { value, index: this.index });
      },
      deep: true,
    },
    allotment: {
      handler(value) {
        this.setLocalAllotment(value);
        this.setDays();
      },
      deep: true,
    },
  },
};
</script>

<template>
  <tr class="table-row">
    <td class="ma-0 pa-0">
      <v-menu
        v-model="datePickerMenuFromDate"
        :close-on-content-click="false"
        :nudge-right="20"
        lazy
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="localAllotment.fromDate | moment('DD-MM-YYYY')"
            hide-details
            solo
            readonly
            :disabled="readOnly"
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="localAllotment.fromDate"
          @input="datePickerMenuFromDate = false"
        />
      </v-menu>
    </td>
    <td class="ma-0 pa-0">
      <v-menu
        v-model="datePickerMenuToDate"
        :close-on-content-click="false"
        :nudge-right="20"
        lazy
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="localAllotment.toDate | moment('DD-MM-YYYY')"
            :disabled="readOnly"
            hide-details
            solo
            readonly
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="localAllotment.toDate"
          :min="localAllotment.fromDate"
          :disabled="readOnly"
          @input="datePickerMenuToDate = false"
        />
      </v-menu>
    </td>
    <td class="ma-0 pa-0">
      <v-menu
        v-model="datePickerMenuReleaseDate"
        :close-on-content-click="false"
        :nudge-right="20"
        lazy
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="localAllotment.releaseDate | moment('DD-MM-YYYY')"
            :label="$t('nonDynamicTransport.headers.releaseDate')"
            :disabled="!!localAllotment.releaseDays || readOnly"
            :clear-icon-cb="clearReleaseDate"
            solo
            readonly
            clearable
            hide-details
            v-on="on"
          />
        </template>
        <v-date-picker
          v-model="localAllotment.releaseDate"
          @input="datePickerMenuReleaseDate = false"
        />
      </v-menu>
    </td>
    <td class="ma-0 pa-0 table-icon">
      <v-text-field
        v-model="localAllotment.releaseDays"
        :label="$t('nonDynamicTransport.headers.releaseDays')"
        :disabled="!!localAllotment.releaseDate || readOnly"
        hide-details
        solo
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.issue"
        :label="$t('nonDynamicTransport.headers.issue')"
        :disabled="readOnly"
        hide-details
        solo
      />
    </td>
    <td class="ma-0 pa-0 table-icon">
      <non-dynamic-transport-notifications
        :notifications="localAllotment.notifications"
        :read-only="readOnly"
        @save="setNotifications"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.PNR"
        :label="$t('nonDynamicTransport.headers.pnr')"
        :disabled="readOnly"
        hide-details
        solo
      />
    </td>
    <td class="ma-0 pa-0 table-icon">
      <v-dialog v-model="infoModal" persistent max-width="300">
        <template v-slot:activator="{ on }">
          <v-btn class="table-icon" v-on="on" fab small color="primary">
            <v-icon v-on="on" dark>info</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{
              $t("nonDynamicTransport.labels.information")
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="localAllotment.comment"
              :label="$t('nonDynamicTransport.labels.comment')"
              :disabled="readOnly"
              hide-details
              solo
            />
          </v-card-text>
          <v-divider class="mr-2 ml-2" />
          <v-card-actions>
            <v-spacer />
            <v-btn color="success" @click="infoModal = false">
              {{ $t("buttons.save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.amount"
        :label="$t('nonDynamicTransport.labels.amount')"
        :disabled="readOnly"
        hide-details
        class="data-two-digit"
        solo
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model.number="localAllotment.fares.net"
        @change="calculateTotalFare"
        :label="$t('nonDynamicTransport.headers.netFare')"
        :disabled="readOnly"
        hide-details
        solo
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model.number="localAllotment.fares.fuel"
        :label="$t('nonDynamicTransport.headers.yr')"
        :disabled="readOnly"
        hide-details
        solo
        @change="calculateTotalFare"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model.number="localAllotment.fares.tax"
        :label="$t('nonDynamicTransport.headers.taxes')"
        :disabled="readOnly"
        hide-details
        rounded
        solo
        @change="calculateTotalFare"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.fares.total"
        :label="$t('nonDynamicTransport.headers.totalFare')"
        hide-details
        disabled
        solo
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="percentages.totalFare"
        :disabled="readOnly"
        hide-details
        label="%"
        class="table-percentage"
        solo
        @change="calculateCustomerPrice"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.prices.adult"
        :label="$t('nonDynamicTransport.headers.customerPrice')"
        :disabled="readOnly"
        hide-details
        solo
        @change="calculateTotalFarePercentage"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.prices.infant"
        :label="$t('nonDynamicTransport.headers.infant')"
        :disabled="readOnly"
        hide-details
        solo
        @change="calculateInfantPercentage"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="percentages.infant"
        :disabled="readOnly"
        class="table-percentage"
        hide-details
        solo
        @change="calculateInfantPrice"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.prices.child"
        :label="$t('nonDynamicTransport.headers.child')"
        :disabled="readOnly"
        hide-details
        solo
        @change="calculateChildPercentage"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="percentages.child"
        :disabled="readOnly"
        hide-details
        solo
        @change="calculateChildPrice"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-text-field
        v-model="localAllotment.classType"
        :label="$t('nonDynamicTransport.headers.class')"
        :disabled="readOnly"
        hide-details
        solo
      />
    </td>
    <td class="ma-0 pa-0">
      <v-icon color="success" disabled> directions_boat </v-icon>
    </td>
    <td class="ma-0 pa-0">
      <v-select
        :items="days"
        :disabled="readOnly"
        item-text="label"
        v-model="outboundDays"
        multiple
        solo
        persistent-hint
        return-object
        hide-details
        @change="updateOutboundDays"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-select
        :items="days"
        :disabled="readOnly"
        item-text="label"
        item-value="label"
        v-model="inboundDays"
        multiple
        solo
        persistent-hint
        return-object
        hide-details
        @change="updateInboundDays"
      />
    </td>
    <td class="ma-0 pa-0">
      <v-icon v-if="!readOnly" color="red" @click="$emit('remove', index)">delete</v-icon>
      <v-icon v-else color="red" @click="$emit('remove')"> delete </v-icon>
      <v-icon v-if="readOnly" @click="openNDT()">edit</v-icon>
    </td>
  </tr>
</template>

<style scoped lang="scss">
@import "../../assets/scss/variables";

/deep/ .v-text-field .v-label {
  font-size: $font-size-sm - 1px;
}

/deep/ .v-text-field {
  font-size: $font-size-sm;
}

/deep/ .table-icon .v-btn {
  min-width: 10px;
  width: 30px;
  height: 30px;
}

/deep/ .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px;
}

/deep/
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  padding: 0 4px;
}

/deep/ .v-input input {
  color: black !important;
  text-align: center;
}

.table-row {
  td:nth-child(1) {
    width: 5.3%;
  }
  td:nth-child(2) {
    width: 5.3%;
  }
  td:nth-child(3) {
    width: 5%;
  }
  td:nth-child(4) {
    width: 3%;
  }
  td:nth-child(5) {
    width: 2.5%;
  }
  td:nth-child(6) {
    width: 4%;
  }
  td:nth-child(7) {
    width: 8%;
  }
  td:nth-child(8) {
    width: 3%;
  }
  td:nth-child(9) {
    width: 3%;
  }
  td:nth-child(10) {
    width: 4.2%;
  }
  td:nth-child(11) {
    width: 4.2%;
  }
  td:nth-child(12) {
    width: 4.2%;
  }
  td:nth-child(13) {
    width: 4.2%;
  }
  td:nth-child(14) {
    width: 3%;
  }
  td:nth-child(15) {
    width: 4.5%;
  }
  td:nth-child(16) {
    width: 4%;
  }
  td:nth-child(17) {
    width: 3%;
  }
  td:nth-child(18) {
    width: 4%;
  }
  td:nth-child(19) {
    width: 3%;
  }
  td:nth-child(20) {
    width: 2.5%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportAllotmentRow.vue